function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import anime from 'animejs';
var animationBaseConfig = {
  duration: 500,
  easing: 'linear'
};
export var enterAnimation = function enterAnimation(ref) {
  return anime(_extends({}, animationBaseConfig, {
    targets: ref.current,
    opacity: [0, 1],
    translateY: ['100%', 0]
  }));
};
export var exitAnimation = function exitAnimation(ref) {
  return anime(_extends({}, animationBaseConfig, {
    targets: ref.current,
    opacity: [1, 0],
    translateY: [0, '-100%']
  }));
};